import React, { useState } from 'react';
import ChatList from './ChatList';
import ChatView from './ChatView';
import { Box } from '@mui/material';
import Typography from "assets/theme/base/typography";
import { useParams } from 'react-router-dom';
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import {useGetAllChatListQuery} from 'slices/chatApi'
const chats = [
  { name: 'Alice', lastMessage: 'Hey, how are you?', messages: [{ sender: 'Alice', text: 'Hey, how are you?' }] },
  { name: 'Bob', lastMessage: 'Are we meeting tomorrow?', messages: [{ sender: 'Bob', text: 'Are we meeting tomorrow?' }] },
];
  

const ChatPage = () => {
    const { email } = useParams(); // Access the route param
    const [selectedChat, setSelectedChat] = useState(null);
    const { data, isLoading, error } = useGetAllChatListQuery({ email });
    console.log(data);
  return (
    <DashboardLayout>
        <DashboardNavbar/>
    <Box display="flex" height="100vh">
      <Box sx={{ width: '25%' }}>
        <ChatList chats={data} onChatSelect={(chat) => setSelectedChat(chat)} />
      </Box>
      <Box sx={{ flex: 1 }}>
        {selectedChat ? (
          <ChatView selectedChat={selectedChat} />
        ) : (
          <Box p={2}>
            <h6>Select a chat to view messages</h6>
          </Box>
        )}
      </Box>
    </Box>
    <Footer />
    </DashboardLayout>
  );
};

export default ChatPage;
